import { Controller } from "@hotwired/stimulus";

/**
 * Disable the spend limit inputs when the selected budget frequency
 * does not support payment blocking.
 *
 * The supported frequencies are provided server-side:
 *   <div data-controller="sub-budget"
 *        data-sub-budget-supported-frequencies-value='["DAILY","WEEKLY","MONTHLY"]'
 *        data-action="change->sub-budget#update">
 *     ...budget form...
 *   </div>
 *
 * The amount is stashed in a data attribute so it can be restored when
 * switching back to a supported frequency.
 */
export default class SubBudgetController extends Controller<HTMLElement> {
  static override values = {
    supportedFrequencies: Array,
  };
  declare readonly supportedFrequenciesValue: string[];

  override connect(): void {
    this.update();
  }

  update(): void {
    const frequency = this.element.querySelector<HTMLSelectElement>(
      'select[name="frequency"]',
    );
    const disabled =
      frequency !== null &&
      frequency.value !== "" &&
      !this.supportedFrequenciesValue.includes(frequency.value);

    const amount = this.element.querySelector<HTMLInputElement>(
      'input[name="spend_limit_amount_0"]',
    );
    if (amount !== null) {
      if (disabled && amount.value !== "") {
        amount.dataset.stashedValue = amount.value;
        amount.value = "";
      } else if (
        !disabled &&
        amount.value === "" &&
        amount.dataset.stashedValue
      ) {
        amount.value = amount.dataset.stashedValue;
        delete amount.dataset.stashedValue;
      }
      amount.disabled = disabled;
      amount.setAttribute("aria-disabled", String(disabled));
    }

    const currency = this.element.querySelector<HTMLSelectElement>(
      'select[name="spend_limit_amount_1"]',
    );
    if (currency !== null) {
      currency.disabled = disabled;
      currency.setAttribute("aria-disabled", String(disabled));
    }
  }
}
